import type { DateKey } from '@features/quote/utils/dateKey';

// D8/D9: never before today, never before the previous row's date.
export function resolveEditableDateFloor(
    previousRowDate: DateKey | undefined,
    today: DateKey
): DateKey {
    return previousRowDate && previousRowDate > today ? previousRowDate : today;
}
